import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxLeaveRequest = createAsyncThunk('inboxLeave/getRequest', async (data) => {
    try {
        const response = await axios.post('/LeaveRequest/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxLeaveChangeRemarks = createAsyncThunk('inboxLeave/updateRemarks', async (data) => {
    try {
        const response = await axios.put('/LeaveRequest/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxLeaveSlice = createSlice({
    name: 'inboxLeave',
    initialState: {
        leave: []
    },
    reducers: {
        removeInboxLeave: (state) => {
            state.leave = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxLeaveRequest.fulfilled, (state, action) => {
            state.leave = action?.payload;
        });
    }
});

export const { removeInboxLeave } = inboxLeaveSlice.actions;
export default inboxLeaveSlice.reducer;
